import { render, staticRenderFns } from "./MOHItem.vue?vue&type=template&id=c48abf32&"
import script from "./MOHItem.vue?vue&type=script&lang=js&"
export * from "./MOHItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports